<template>
  <div class="not-authenticated-container">
    <div class="container-fluid h-100">
      <div class="row justify-content-center align-items-center min-vh-100">
        <div class="col-lg-5 col-md-7 col-sm-9 col-11">
          <div class="card shadow-lg border-0">
            <div class="card-body text-center p-4">
              <div class="mb-4">
                <div class="mb-3">
                  <img
                    :src="origin + '/img/logo2024.png'"
                    alt="Teorema Sistemas"
                    class="logo-img"
                  >
                </div>
                <i class="fa fa-lock fa-4x text-warning mb-3"></i>
                <h2 class="text-dark font-weight-bold mb-3">Acesso Restrito</h2>
                <p class="text-muted lead mb-4">
                  Você precisa estar autenticado para acessar esta área.
                </p>
              </div>

              <div class="mb-4">
                <a
                  :href="authFrontUrl"
                  class="btn btn-primary btn-lg px-4 py-2 font-weight-bold"
                >
                  <i class="fa fa-sign-in mr-2"></i>
                  Fazer Login
                </a>
              </div>

              <div class="text-muted small">
                <p class="mb-2">
                  <i class="fa fa-info-circle mr-1"></i>
                  Se você já possui uma conta, clique no botão acima para fazer login.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loginBackground from '@/assets/img/fundo_teorema_30_anos.jpg'

export default {
  name: 'NotAuthenticated',
  props: {
    authFrontUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      backgroundImage: loginBackground,
      origin: window.location.origin
    }
  }
}
</script>

<style scoped>
.not-authenticated-container {
  background-image: v-bind('`url(${backgroundImage})`');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  position: relative;
}

.not-authenticated-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
}

.not-authenticated-container .container-fluid {
  position: relative;
  z-index: 2;
}

.card {
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.logo-img {
  max-height: 160px;
  width: auto;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.fa-lock {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.text-warning {
  color: #ffc107 !important;
}

.lead {
  font-size: 1.1rem;
  line-height: 1.6;
}

.min-vh-100 {
  min-height: 100vh;
}

.h-100 {
  height: 100%;
}
</style>
